module.exports = __webpack_public_path__ + "img/404-responsive.44bf1fa6.jpg";